import api from "./index"
const PROJECT = "fsc"
// eslint-disable-next-line
export default {
  loadFile(data) {
    return api().post("/file", data, { withCredentials: true })
  },

  getCurrentUserData(uid) {
    return api().get(`/${PROJECT}/objects/${uid}`, { withCredentials: true })
  },

  checkSession(uid) {
    return api().get(`/${PROJECT}/checkSession/${uid}`, { withCredentials: true })
  },

  updateUser(user) {
    const project = "fsc";
    const object = user.object;
    const system = user.system;
    const data = {
      project,
      object: JSON.stringify(object),
      system: JSON.stringify(system)
    }
    return api().post(`/objects/${user.id}`, data, { withCredentials: true })
  },

  createUser({ login, password, email, inn, phone, company, role, chkReq, chkComm }) {
    const project = "hcvf"
    return api().get(`/register?login=${login}&password=${password}&email=${email}&inn=${inn}&phone=${phone}&company=${company}&role=${role}&project=${project}&chkReq=${chkReq}&chkComm=${chkComm}`
    , { withCredentials: true })
  },

  restorePassword(login) {
    const project = "hcvf"
    return api().get(`/recover?project=${project}&name=${login}`)
  },

  restorePasswordChange(id, password) {
    const project = "hcvf"
    return api().get(`/register/recover/${id}?password=${password}&project=${project}`)
  }
};